// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import { IStateIdList } from "./states";
import { ConnectorStatus } from "model/connector";
import { ChargerStatusNotificationSource } from "graphql/api";

export interface ITrendDataRow {
  regperiod: number;
  energy: number;
  power: number;
  costs?: number;
  tariff?: number;
  targetpower?: number;
  // only for charger trending
  soc?: number;
}
export type ITrendDataTimestamp = ITrendDataRow[]; // array index: tlId, connector-id
export interface ITrendData {
  [timestamp: number]: ITrendDataTimestamp; // timestamp in s
}

export type IIoTrendIos = number[]; // array index: input/output index
export type IIoTrendTimestamp = IIoTrendIos[]; // array index: 0..input, 1..output

export interface IIoTrend {
  [timestamp: number]: IIoTrendTimestamp; // timestamp in s
}
export type IIoTrendCounts = number[];
export type IIoTrendCountsTimestamp = IIoTrendCounts[]; // array index: output index
export interface IIoTrendCount {
  [timestamp: number]: IIoTrendCountsTimestamp; // timestamp in s
}

export interface IChargerStateEvent {
  id: number;
  fk_charger: number;
  connector: number;
  timestamp: number;
  source: ChargerStatusNotificationSource;
  statusCode: ConnectorStatus;
  errorCode: string;
  info: string | undefined;
}

export interface IStateTrending {
  trendData: ITrendData; // number[timestamp][tlId][TrendMember]
  ioTrendAggr: IIoTrend;
  ioTrendFull: IIoTrend;
  ioTrendCount: IIoTrendCount;
  isIoTrendRestricted: boolean;
  queryMoreData: boolean;

  // available on LINX and embyt controller
  nextReadSeq?: number[];

  // only available on embyt controller
  totalCnt?: number[];

  // only available in cloud
  minTrendTimestamp?: number | undefined;
  maxTrendTimestamp?: number | undefined; // s
  minIoTimestamp?: number | undefined;
  maxIoTimestamp?: number | undefined;
  chargerTrend?: IStateIdList<ITrendData>; // charger_fk as idList key; number[timestamp][tlId][TrendMember]
  chargerStateData?: IChargerStateEvent[];
}

/* initial state */
export const INITIAL_STATE: IStateTrending = {
  trendData: {},
  ioTrendAggr: {},
  ioTrendFull: {},
  ioTrendCount: {},
  isIoTrendRestricted: false,
  queryMoreData: false,
};
